import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitTo'
})
export class LimitToPipe implements PipeTransform {

  transform(input: any[], limit: number):any[] {
        if (!Array.isArray(input))
            return [];

    let temp: any[] = [];
        for (let i = 0; i < limit; i++) {
            if (input[i] !== undefined) {
                temp.push(input[i]);
            }
        }

        return temp;
  }

}
